// Studyo Today Backend
// Package studyo.schools.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/account_kind.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/account_kind.proto.
 */
export const file_studyo_today_schools_v1_resources_account_kind = /*@__PURE__*/
  fileDesc("CjRzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvYWNjb3VudF9raW5kLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMqXwoLQWNjb3VudEtpbmQSHAoYQUNDT1VOVF9LSU5EX1VOU1BFQ0lGSUVEEAASGAoUQUNDT1VOVF9LSU5EX1RFQUNIRVIQARIYChRBQ0NPVU5UX0tJTkRfU1RVREVOVBACQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.AccountKind.
 */
export const AccountKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_account_kind, 0);

/**
 * All possible account kinds
 *
 * @generated from enum studyo.today.schools.v1.resources.AccountKind
 */
export const AccountKind = /*@__PURE__*/
  tsEnum(AccountKindSchema);

